import { AppCoreEnums } from '../shared/enums';
import useRouterUtils from 'src/core/router-utils/route-utils';
import { IRouteMeta, IRouteMetaPermissions } from '../models/routing';
import { RouteLocationNormalized, RouteRecordNormalized, Router } from 'vue-router';

export default () => {
  const { getContainerRouteIndex } = useRouterUtils();

  const getRoutePermissions = (
    route: RouteLocationNormalized,
    containerType: AppCoreEnums.ContainerType | undefined
  ): IRouteMetaPermissions | undefined => {
    let routeContainerPermissions: IRouteMetaPermissions | undefined = undefined;

    if (containerType != undefined) {
      let index = getContainerRouteIndex(route, containerType);
      while (index >= 0) {
        routeContainerPermissions = (route.matched[index].meta as IRouteMeta)?.permissions;
        if (routeContainerPermissions) break;
        index--;
      }
    }

    return routeContainerPermissions;
  };

  const getRoutePermissionsByRouteName = (
    routeName: string,
    router: Router,
    searchParentPermissions = false
  ): IRouteMetaPermissions | undefined => {
    const routes = router.getRoutes();

    const route = routes.find((x) => x.name === routeName);
    let permissions = (route?.meta as IRouteMeta)?.permissions;
    if (!permissions && searchParentPermissions) {
      let parentRoute = undefined;
      do {
        parentRoute = getParentRoute(routes, parentRoute?.name?.toString() || routeName);
        permissions = (parentRoute?.meta as IRouteMeta)?.permissions;
        if (permissions) break;
      } while (parentRoute);
    }

    return permissions;
  };

  const getParentRoute = (routes: RouteRecordNormalized[], routeName: string): RouteRecordNormalized | undefined => {
    return routes.find((x) => {
      const child = x.children?.find((x) => x.name === routeName);
      if (child) return !!x;
      else return false;
    });
  };

  return {
    getRoutePermissions,
    getRoutePermissionsByRouteName,
  };
};
